<template>
    <LandingPageLayout
        v-bind="landingPageSharedData.getLandingPageLayoutProps()"
    >
        <article class="max-w-4xl mx-auto py-4 px-6 lg:px-0 flex-1">
            <div class="space-y-8 mb-20">
                <header>
                    <h1 class="text-3xl font-semibold">Customer Support</h1>
                </header>

                <section
                    class="space-y-4"
                    aria-label="Support availability"
                >
                    <p>
                        We make great effort to provide our customers with the
                        best possible support. That's why we do everything we
                        can to respond to support requests as soon as possible.
                    </p>
                    <p>
                        Our support team is available between 8AM and 6PM
                        (America/Fortaleza).
                    </p>
                </section>

                <section
                    class="space-y-4"
                    aria-labelledby="support-help-heading"
                >
                    <h2
                        id="support-help-heading"
                        class="text-xl font-semibold"
                    >
                        How to get help
                    </h2>
                    <p>
                        Email us at "contact@tinycal.net" and we will get back
                        to you as soon as we can.
                    </p>
                </section>
            </div>
        </article>
    </LandingPageLayout>
</template>

<script setup lang="ts">
    import LandingPageLayout from '@/Marketing/LandingPage/Shared/LandingPageLayout.vue'
    import LandingPageSharedData from '@/Marketing/LandingPage/Entity/LandingPageSharedData'

    interface LandingPageProps {
        landingPageSharedDataRawData: any
    }

    const props = defineProps<LandingPageProps>()
    const landingPageSharedData = LandingPageSharedData.hydrate(
        props.landingPageSharedDataRawData,
    )
</script>
